<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const kanbanUrl = 'https://kanban.vps9164.panel.icontainer.run';
const kanbanOrigin = new URL(kanbanUrl).origin;

const route = useRoute();
const router = useRouter();

const handleMessage = event => {
  if (event.origin !== kanbanOrigin) return;
  if (event.data?.source !== 'kanbanwoot') return;
  if (event.data?.type === 'open-conversation' && event.data?.conversationId) {
    router.push({
      name: 'inbox_conversation',
      params: {
        accountId: route.params.accountId,
        conversation_id: event.data.conversationId,
      },
    });
  }
};

onMounted(() => window.addEventListener('message', handleMessage));
onUnmounted(() => window.removeEventListener('message', handleMessage));
</script>

<template>
  <div class="kanban-embed">
    <iframe :src="kanbanUrl" class="kanban-embed__iframe" title="Kanban" />
  </div>
</template>

<style scoped>
.kanban-embed {
  height: 100%;
  width: 100%;
}

.kanban-embed__iframe {
  height: 100%;
  width: 100%;
  border: 0;
}
</style>
